import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { extractProperty } from "utils"
import AccordionComponent from "../ContactUs/components/Accordion"

type Props = {
  data: any
}

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding-bottom: 48px;
  padding-top: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr;
    gap: 64px;
  }
`

const StyledText = styled(Typography)`
  font-size: 20px !important;
  line-height: 28px !important;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 24px !important;
    line-height: 32px !important;
  }
`
const HoursContactInfo = ({ data }: Props) => {
  const title = extractProperty(data, "title")
  return (
    <>
      <StyledText variant="h3">{title}</StyledText>

      <StyledDiv>
        <AccordionComponent data={data} hideButton initialClosed={true} />
      </StyledDiv>
    </>
  )
}

export default HoursContactInfo
